import { GetterTree, MutationTree } from 'vuex';
import { RootState } from '~/store';

export const state = () => ({
  currentTab: null,
  reportType: null
});

export type SKUContentState = ReturnType<typeof state>;

export const getters: GetterTree<SKUContentState, RootState> = {
  getCurrentTab(state) {
    return state.currentTab;
  },
  getReportType(state) {
    return state.reportType;
  }
};

export const mutations: MutationTree<SKUContentState> = {
  changeTab: (state, tab) => (state.currentTab = tab),
  changeReportType: (state, reportType) => (state.reportType = reportType)
};
